import React from "react";

export default function BasicHybridCeramicCoat() {
  return (
    <div className="space-y-2 text-sm text-gray-800">
      <p className="font-semibold">Includes:</p>
      <ul className="list-disc text-black-500 ">
        <li className="font-bold">Hybrid Ceramic Coating</li>
        <li className="font-bold">Exterior High Pressure Wash</li>
        <li className="font-bold">Exterior Foam Wash</li>
        <li className="font-bold">Exterior Glass Polish</li>
     
          <b>
            CLEANING INSIDE BONNET IS AT OWNER'S RISK. - NOT RECOMMENDED (RS
            100 EXTRA)
          </b>
     
      </ul>
     
    </div>
  );
}


